import React, { useEffect, useState } from "react";
import "./groups.css";
import { ChevronRight, EllipsisVertical, Users } from "lucide-react";
import NewGroup from "./NewGroup";
import { useNavigate } from "react-router-dom";
import GroupCard from "./Group/GroupCard";
import apiServiceHandler from "../../service/apiService";
import { useDispatch, useSelector } from "react-redux";
import { hanldeGroups } from "../../redux/groupData";

const Groups = () => {
  const [groups, setGroups] = useState([])
  const loadGroups = useSelector((state) => state.groupData.loadGroups)
  const dispatch = useDispatch()
  const userDetails = JSON.parse(localStorage.getItem('userDetails'))
  const isAdmin = userDetails?.admin

  const getAllGroups = async () => {
    try {
      const response = await apiServiceHandler("GET", "api/groups", {});
      setGroups(response.data);
    } catch (error) {
      console.error("Error getting getAllUsers:", error);
    }
  };


  useEffect(() => {
    getAllGroups()
  }, [])

  useEffect(() => {
    if (loadGroups) {
      getAllGroups()
    }
    dispatch(hanldeGroups(false))
  }, [loadGroups])


  return (
    <div className="">
      <div className="group-page__content">
        <div className="group-page-section">
          <div className="group-page-section-header">
            <div className="group-page-header">
              <div className="group-page-header__eyebrow">
                The heart of our community
              </div>
              <div className="group-page-header__top">
                <div className="group-page-header__content">
                  <div className="group-page-header__heading">
                    <span className="jurni-font-roboto">Groups</span>
                  </div>
                </div>
                <div className="group-page-header__action"></div>
              </div>
            </div>
          </div>

          {/* body */}
          <div className="group-page-section__body">
            <div className="card-grid-container">
              {groups && groups.length > 0 ? groups.map((group) => (
                <div key={group._id}>
                  <GroupCard group={group} />
                </div>
              )) : !isAdmin && <div className="no-group">Currently you do not have access to any Group.</div>}
              {isAdmin && <NewGroup />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Groups;
